import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface Departments {
  name: string;
  api_token: string;
}

export interface DepartmentsListInfor {
  errors: unknown;
  departments: Departments;
  isAuthenticated: boolean;
}

@Module
export default class DepartmentsModule
  extends VuexModule
  implements DepartmentsListInfor
{
  errors = {};
  departments = {} as Departments;
  isAuthenticated = !!JwtService.getToken();

  get Departments() {
    return this.departmentsListData;
  }

  @Mutation
  [Mutations.DEPARTMENTS_LIST_DATA](Departments) {
    this.departmentsListData = Departments;
  }

  @Action
  [Actions.DEPARTMENTS_LIST](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("/department", payload)
        .then((data) => {
          this.context.commit(Mutations.DEPARTMENTS_LIST_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.DEPARTMENT_CREATE](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("department/upsert", payload)
        .then((data) => {
          this.context.commit(Mutations.DEPARTMENTS_LIST_DATA, data);
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.DEPARTMENT_UPDATE](payload) {
    const id = payload.get("id");
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.getDataDetail("/department", "upsert", id, payload)
        .then((data) => {
          this.context.commit(Mutations.DEPARTMENTS_LIST_DATA, data);
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.DEPARTMENT_DELETE](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.getDataDetail("/department", payload, "delete", payload)
        .then((data) => {
          this.context.commit(Mutations.DEPARTMENTS_LIST_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }
}
